var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8675 11.2634H21.7402V28.1964H15.9343V11.2634H14.807L18.7463 6.35436C18.7948 6.30587 18.8676 6.30587 18.916 6.35436L22.8675 11.2634Z",
    fill: "#20A6D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6545 6.3786H12.5394V28.1964H6.73344V6.3786H5.60619L9.54552 1.46959C9.594 1.42111 9.66673 1.42111 9.71521 1.46959L13.6545 6.3786Z",
    fill: "#20A6D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9817 16.0633H30.8544V28.2813H25.0485V16.0633H23.9212L27.8605 11.1543C27.909 11.1058 27.9818 11.1058 28.0302 11.1543L31.9817 16.0633Z",
    fill: "#20A6D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56274 28.5L35.1978 28.5C35.4036 28.5 35.5627 28.5 35.5627 28.5V28.5",
    stroke: "#20A6D2",
    strokeWidth: 0.727261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.a8033beab40530ceb4b7aadd36f166eb.svg";
export { ForwardRef as ReactComponent };